const StoryFooter = () => (
	<div>
		<h4>Application Storyline Page – Footer</h4>
		<p>We offer the option of downloading sample data for individual cities.</p>
	</div>
);

export default StoryFooter;
